module.exports = __webpack_public_path__ + "img/checkbox.9af66a9.svg";